import * as React from "react";
import {
  UseFormRegister,
  FieldValues,
  FieldValue,
  DeepMap,
  FieldError, RegisterOptions,
} from 'react-hook-form'
import { IconType } from 'react-icons'

interface IInput {
  placeholder: string;
  type?: string;
  name?: FieldValue<any>;
  className?: string;
  register?: UseFormRegister<FieldValues>;
  errors?: DeepMap<FieldValues, FieldError>;
  defaultValue?: any;
  required?: boolean;
  block?: boolean;
  disabled?: boolean;
  rules?:RegisterOptions;
  Icon?:any;
}

const Input: React.FC<IInput> = ({
  placeholder,
  type = "text",
  className = "",
  name,
  register,
  errors,
  defaultValue,
  required,
  block,
  disabled,
  rules,
  Icon,
}: IInput) => {
  let styleInput = `form-control ${className}`;
  let styleWrapper = `input-wrapper w-full`;
  
  if (block) {
    styleInput = `form-control w-full ${className}`;
  }
  
  if(Icon){
    styleWrapper += ' input-group-icon';
  }
  
  const registerOptions = rules ?? {}
  
  const InputPlain = () => {
    return (
      <div className={styleWrapper}>
        {Icon && <Icon size={'1rem'} className={'left-icon'} />}
        <input
          required={required}
          className={styleInput}
          placeholder={placeholder}
          type={type}
          name={name}
          disabled={disabled}
          defaultValue={defaultValue}
        />
      </div>
    )
  }

  return register ? (
    <div className={styleWrapper}>
      <input
        id={name}
        required={required}
        className={styleInput}
        placeholder={placeholder}
        type={type}
        defaultValue={defaultValue}
        disabled={disabled}
        {...register(name,registerOptions)}
      />
      {Icon && <Icon size={'1.25rem'} className={'icon'} />}
      {errors?.[name] && (
        <p className="text-red-600 italic mb-2">
          {errors[name].message}
        </p>
      )}
    </div>
  ) : <InputPlain />;
};

export default Input;
